import axios from "axios";

/**
 * Consulta los datos del tablero de soportes históricos
 * @param {Object} data - Datos de búsqueda
 * @returns {Promise<Array>} Lista de registros obtenidos
 */


export async function getConsultAllList(data) {
  try {
    const response = await axios.get("/Seguridad/Url/GetAll", data);
    return response.data;
  } catch (error) {
    // Lanzamos el error para manejarlo en el componente
    throw error.response ? error.response : error;
  }
}

export async function getConsultAll(data) {
  try {
    const response = await axios.post("/Seguridad/Url/Get", data);
    return response.data;
  } catch (error) {
    // Lanzamos el error para manejarlo en el componente
    throw error.response ? error.response : error;
  }
}

export async function postInsert(data) {
  try {
    const response = await axios.post("/Seguridad/Url/Post/", data);
    return response.data;
  } catch (error) {
    // Lanzamos el error para manejarlo en el componente
    throw error.response ? error.response : error;
  }
}

export async function putUpdate(data) {
  try {
    const response = await axios.put("/Seguridad/Url/Put/", data);
    return response.data;
  } catch (error) {
    // Lanzamos el error para manejarlo en el componente
    throw error.response ? error.response : error;
  }
}

export async function Delete(data) {
  try {
    const response = await axios.delete("/Seguridad/Url/Delete", { data });
    return response.data;
  } catch (error) {
    // Lanzamos el error para manejarlo en el componente
    throw error.response ? error.response : error;
  }
}